// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2sfX6","actionsCol":"EnrolledClinics_actionsCol__1DafW"};